"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const hero_data_1 = tslib_1.__importDefault(require("../fixtures/hero-data"));
exports.HeroData = hero_data_1.default;
const __1 = require("../");
const normal_attack_1 = tslib_1.__importDefault(require("./common/normal-attack"));
const ai_1 = require("./ai");
const amanojakuao_1 = require("./n/amanojakuao");
const nurikabe_1 = require("./n/nurikabe");
const kiseirei_1 = require("./n/kiseirei");
const karakasakozou_1 = require("./n/karakasakozou");
const houkikami_1 = require("./n/houkikami");
const hakaarashinorei_1 = require("./n/hakaarashinorei");
const chouchinkozou_1 = require("./n/chouchinkozou");
const amanojakumidori_1 = require("./n/amanojakumidori");
const amanojakuki_1 = require("./n/amanojakuki");
const amanojakuaka_1 = require("./n/amanojakuaka");
const akajita_1 = require("./n/akajita");
const miketsu_1 = require("./ssr/miketsu");
const ootengu_1 = require("./ssr/ootengu");
const shutendoji_1 = require("./ssr/shutendoji");
exports.HeroTable = new Map(lodash_1.map(hero_data_1.default, (data) => [data.id, data]));
exports.HeroTableByName = new Map(lodash_1.map(hero_data_1.default, (data) => [data.name, data]));
exports.HeroBuilders = new Map();
function build(no, tags, ai, ...skills) {
    const data = exports.HeroTable.get(no);
    exports.HeroBuilders.set(no, function () {
        const entity = new __1.Entity();
        if (data) {
            entity.setProperty(__1.BattleProperties.MAX_HP, data.hp);
            entity.setProperty(__1.BattleProperties.ATK, data.atk);
            entity.setProperty(__1.BattleProperties.DEF, data.def);
            entity.setProperty(__1.BattleProperties.SPD, data.spd);
            entity.setProperty(__1.BattleProperties.CRI, data.cri);
            entity.setProperty(__1.BattleProperties.CRI_DMG, data.cri_dmg);
            entity.rank = data.rank;
            entity.hp = data.hp;
            entity.name = data.name;
            entity.no = data.id;
            entity.ai = ai;
            lodash_1.forEach(tags, t => {
                entity.addTags(t);
            });
            lodash_1.forEach(skills, s => {
                entity.addSkill(s);
            });
        }
        return entity;
    });
}
exports.HeroTable.forEach((_, no) => {
    build(no, ['simple'], ai_1.normalAI, new normal_attack_1.default('普通攻击'));
});
function HERO(name, skills, ai = ai_1.normalAI) {
    const dd = hero_data_1.default.find(d => d.name === name.trim());
    if (!dd)
        throw new Error('找不到[' + name + ']');
    build(dd.id, [], ai, ...skills);
}
// N
HERO('赤舌', [
    akajita_1.akajita_skill1,
    akajita_1.akajita_skill2,
    akajita_1.akajita_skill3,
]);
HERO('天邪鬼赤', [
    amanojakuaka_1.amonojakuaka_skill1,
    amanojakuaka_1.amonojakuaka_skill2,
]);
HERO('天邪鬼青', [
    amanojakuao_1.amonojakuao_skill1,
    amanojakuao_1.amonojakuao_skill2,
]);
HERO('天邪鬼黄', [
    amanojakuki_1.amanojakuki_skill1,
    amanojakuki_1.amanojakuki_skill2,
]);
HERO('天邪鬼绿', [
    amanojakumidori_1.amanojakumidori_skill1,
    amanojakumidori_1.amanojakumidori_skill2,
]);
HERO('提灯小僧', [
    chouchinkozou_1.chouchinkozou_skill1,
    chouchinkozou_1.chouchinkozou_skill2
]);
HERO('盗墓小鬼', [
    hakaarashinorei_1.hakuarashinorei_skill1,
]);
HERO('帚神', [
    houkikami_1.houkikami_skill1,
    houkikami_1.houkikami_skill2,
]);
HERO('唐纸伞妖', [
    karakasakozou_1.karakasakozou_skill1,
    karakasakozou_1.karakasakozou_skill2,
]);
HERO('寄生魂', [
    kiseirei_1.kiseirei_skill1,
]);
HERO('涂壁', [
    nurikabe_1.nurikabes_skill1,
    nurikabe_1.nurikabes_skill2
]);
//
HERO('御馔津', [
    miketsu_1.miketsu_skill1,
    miketsu_1.miketsu_skill2,
    miketsu_1.miketsu_skill3,
    miketsu_1.miketsu_skill4,
]);
HERO('大天狗', [
    ootengu_1.ootengu_skill1,
    ootengu_1.ootengu_skill2,
    ootengu_1.ootengu_skill3,
]);
HERO('酒吞童子', [
    shutendoji_1.shutendoji_skill1,
    shutendoji_1.shutendoji_skill2,
    shutendoji_1.shutendoji_skill3,
]);
